var loader = require('./dist/flostModule');

module.exports = loader;